export default __webpack_public_path__ + "static/media/hori-rtl.26e4bd8d.png";